
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
let moment = require('moment');
require('moment-timezone');

import "babel-polyfill";
import 'whatwg-fetch';
import '../js/bootstrap.js';
import '../js/carousel.js';
import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';
import Vue from 'vue';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import ReconfirmSession from './components/ReconfirmSession';
import VModal from 'vue-js-modal';
import Translations from './translations';
import Lang from 'lang.js';
import Swal from 'sweetalert2';
import toastr from 'toastr';

Vue.prototype.trans = new Lang({
    messages: Translations,
    locale: window.locale,
    fallback: window.fallback_locale,
});

Vue.use(VModal);
Vue.component('reconfirm-session', ReconfirmSession);
Vue.prototype.$prefix = window.locale == 'en' ? '' : '/es';

window.Vue = Vue;
window.moment = moment;
window.toastr = toastr
window.MarkerClusterer = MarkerClusterer;

window.Swal = Swal;
window.openModal = function (id, closeAction = null) {
    window.Swal.mixin({
        padding: '0',
        showConfirmButton: false,
        width: 700,
    }).fire({
        html: document.getElementById(id).innerHTML,
        willClose: function () {
            (new Function (closeAction))();
        },
    });
};

toastr.options = {
  "closeButton": true,
  "debug": false,
  "newestOnTop": false,
  "progressBar": false,
  "positionClass": "toast-top-right",
  "preventDuplicates": true,
  "onclick": null,
  "showDuration": "300",
  "hideDuration": "1000",
  "timeOut": "60000",
  "extendedTimeOut": "60000",
  "showEasing": "swing",
  "hideEasing": "linear",
  "showMethod": "fadeIn",
  "hideMethod": "fadeOut"
};

var bugsnagClient = bugsnag({
	apiKey: '4f1d3d07abf0d4f4c417010678f1c282',
	releaseStage: process.env.MIX_APP_ENV,
	notifyReleaseStages: ['production'],
});

bugsnagClient.use(bugsnagVue, Vue);

const app = new Vue({
  components: {
    ReconfirmSession,
  }
}).$mount('#global-app');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */


// const files = require.context('./', true, /\.vue$/i)

// files.keys().map(key => {
//     return Vue.component(_.last(key.split('/')).split('.')[0], files(key))
// })

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
